module.exports = __webpack_public_path__ + "static/reach-out-f0c5d50ebd3f831369724380eced1b78.mp3";